// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';


const engagementCompositeForm = ({ className, displayName, itemComponent }) => {

  class EngagementCompositeForm extends Component {
    constructor(props) {
      super(props);
      this.handleAddItem = this.handleAddItem.bind(this);
    }

    handleAddItem() {
      this.props.onAddItem('', '');
    }

    handleChangeItem(item) {
      return debounce((name, details) => {
        this.props.onUpdateItem(item.id, name, details);
      }, 200);
    }

    handleRemoveItem(item) {
      return () => {
        this.props.onRemoveItem(item.id);
      };
    }

    renderItems() {
      return this.props.items.map((item) => (
        React.createElement(itemComponent, {
          item,
          key: item.id,
          onChange: this.handleChangeItem(item),
          onRemove: this.handleRemoveItem(item)
        })
      ));
    }

    render() {
      return (
        <div className={className}>
          {this.renderItems()}
          <a onClick={this.handleAddItem}>Add row</a>
        </div>
      );
    }
  }

  EngagementCompositeForm.displayName = displayName;
  EngagementCompositeForm.propTypes = {
    items: PropTypes.array.isRequired,
    onAddItem: PropTypes.func.isRequired,
    onUpdateItem: PropTypes.func.isRequired,
    onRemoveItem: PropTypes.func.isRequired
  };

  return EngagementCompositeForm;
};

export default engagementCompositeForm;



// WEBPACK FOOTER //
// ./src/components/analytics/engagementCompositeForm.js